// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"Discover_cardGroup__2L3mi"};